import { theme, styled, utils } from 'ui/theme';

export const Layout = {
  Component: styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    &[data-alternate='true'] {
      background-color: ${theme.colors.build.lightDark2};
    }

    &[data-full-page='true'] {
      min-height: 100vh;
    }

    &[data-horizontal-align='center'] {
      justify-content: center;
    }

    &[data-horizontal-align='left'] {
      justify-content: flex-start;
    }

    &[data-horizontal-align='right'] {
      justify-content: flex-end;
    }

    &[data-loading='true'] {
      align-items: center;
      justify-content: center;
    }

    &[data-vertical-align='center'] {
      align-items: center;
    }

    &[data-vertical-align='top'] {
      align-items: flex-start;
    }

    &[data-vertical-align='bottom'] {
      align-items: flex-end;
    }
  `,
};
